import React, { useState } from 'react';

/**
 * An SVG flag with the Unicode emoji as fallback.
 *
 * Windows renders 🇯🇵 as the two letters "JP", and this tool is used on desktop
 * more than anywhere else in the app — so the flag has to be an image, exactly
 * as `travelkit/src/components/CountryFlag.tsx` decided for the client-facing
 * page. Files live in `web/public/img/flags/<code>.svg`; a missing one drops to
 * the emoji rather than leaving a broken-image box.
 */
const TravelKitCountryFlag = ({ code, flag, size = 22 }) => {
  const [failed, setFailed] = useState(false);

  if (code && !failed) {
    return (
      <img
        className="travelkit-flag"
        src={`/img/flags/${String(code).toLowerCase()}.svg`}
        alt=""
        width={size}
        height={Math.round((size * 3) / 4)}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span className="travelkit-flag travelkit-flag-emoji" style={{ fontSize: size - 4 }} aria-hidden="true">
      {flag || code || '🌐'}
    </span>
  );
};

export default TravelKitCountryFlag;
